import axios from 'axios';
import settings from '../Config';


var axiosInstance = axios.create({
	baseURL: settings.apiBaseUrl
});


export default axiosInstance;